import { render } from "./CampaignDetailsMainCard.vue?vue&type=template&id=3436391b&scoped=true"
import script from "./CampaignDetailsMainCard.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsMainCard.vue?vue&type=script&lang=js"

import "./CampaignDetailsMainCard.vue?vue&type=style&index=0&id=3436391b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3436391b"]])

export default __exports__